(function () {
    'use strict';

    angular
        .module('app')
        .directive('authorsList', authorsList);

    authorsList.$inject = ['$window', 'authorsSearchService'];

    function authorsList($window, authorsSearchService) {
        var directive = {
            bindToController: true,
            controller: ['$scope', controller],
            controllerAs: '$authorsList',
            restrict: 'EA',
            link: link
        };

        return directive;

        function link($scope) {

        }

        function controller($scope) {
            var $ctrl = this;
            
            $ctrl.page = 1;
            $ctrl.pageSize = 10;
            $ctrl.maxPages = 5;
            $ctrl.pages = [];
            $ctrl.results = [];
            $ctrl.shownResults = [];
            $ctrl.totalResults = "";
            $ctrl.sort = "asc";
            $ctrl.loadingImage = $('.loading-overlay');

            $ctrl.search = function (e, pageSize, maxPages) {
                if (e) {
                    e.preventDefault();
                }

                $('#searchResults').hide();
                $ctrl.loadingImage.show();

                $(".ui-menu-item").hide();

                $ctrl.page = 1;
                $ctrl.results = [];
                $ctrl.pageSize = pageSize;
                $ctrl.maxPages = maxPages;

                authorsSearchService.getAuthors()
                    .then(function (results) {
                            results.Authors.forEach(function (result) {
                                $ctrl.results.push(result);
                            });

                            $ctrl.shownResults = $ctrl.results.slice(0, pageSize);

                            var resultsCount = results.Authors.length;
                            $ctrl.totalResults = resultsCount + " Authors";

                            var pageCount = 1;

                            if (resultsCount > pageSize) {
                                pageCount = Math.ceil(resultsCount / pageSize);
                            }
                            var pages = [];

                            for (var index = 1; index <= pageCount; index++) {
                                pages.push(index);
                            }

                            $ctrl.pages = pages;
                        },
                        function () {
                            console.log('an error occured getting results');
                        });

                $ctrl.loadingImage.hide();
                $('#searchResults').show();
            }

            $ctrl.sortByName = function () {
                var skip = ($ctrl.page - 1) * $ctrl.pageSize;

                if ($ctrl.sort === "desc") {
                    $ctrl.sort = "asc";

                    $ctrl.results.sort(byNameAsc);
                } else {
                    $ctrl.sort = "desc";

                    $ctrl.results.sort(byNameDesc);
                }

                $ctrl.shownResults = $ctrl.results.slice(skip, skip + $ctrl.pageSize);
            }

            function byNameDesc(a, b) {
                if (a.AuthorName > b.AuthorName) {
                    return -1;
                }
                if (a.AuthorName < b.AuthorName) {
                    return 1;
                }
                return 0;
            }

            function byNameAsc(a, b) {
                if (a.AuthorName < b.AuthorName) {
                    return -1;
                }
                if (a.AuthorName > b.AuthorName) {
                    return 1;
                }
                return 0;
            }
        }
    }

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_authorsList.js
// module id = 20
// module chunks = 0